export default "__VITE_ASSET__CRt2Wqjj__"